import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

export default function BookCategoryList() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [categories,     setCategories]     = useState([]);
  const [books,          setBooks]          = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeName,     setActiveName]     = useState("");
  const [search,         setSearch]         = useState("");
  const [loading,        setLoading]        = useState(false);
  const [editCategory,   setEditCategory]   = useState(null);
  const [editName,       setEditName]       = useState("");

  const loadCategories = async () => {
    try {
      const res = await API.get("/school-admin/library/categories/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setCategories(res.data.categories || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadCategories(); }, []);

  const loadBooks = async (id, name) => {
    if (activeCategory === id) { setActiveCategory(null); setBooks([]); return; }
    try {
      setLoading(true);
      setActiveCategory(id);
      setActiveName(name);
      const res = await API.get(`/school-admin/library/books/?category=${id}`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setBooks(res.data.books || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const saveEdit = async () => {
    if (!editName.trim()) return alert("Category name required");
    try {
      await API.put(
        `/school-admin/library/categories/${editCategory.id}/update/`,
        { name: editName },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      setEditCategory(null);
      loadCategories();
    } catch (err) { console.error(err); alert("Failed to update"); }
  };

  const filtered = books.filter(b => {
    const q = search.toLowerCase();
    return b.title.toLowerCase().includes(q) ||
      (b.author && b.author.toLowerCase().includes(q)) ||
      (b.isbn && b.isbn.toLowerCase().includes(q));
  });

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">🗂</div>
          <div>
            <h2 className="lb-hero-title">Library Categories</h2>
            <p className="lb-hero-sub">Click a category to view its books — {categories.length} total</p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-back" onClick={() => navigate("/school-admin/library")}>← Dashboard</button>
          <button className="lb-btn-add" onClick={() => navigate("/school-admin/library/categories/add")}>+ Add Category</button>
        </div>
      </div>

      {/* ══ CATEGORY CARDS ══ */}
      <div className="lb-card">
        {categories.length === 0 ? (
          <div className="lb-empty">
            <div className="lb-empty-icon">📂</div>
            <strong>No categories yet</strong>
            <p>Create a category to organise your books</p>
          </div>
        ) : (
          <div className="lb-cat-grid">
            {categories.map(c => (
              <div
                key={c.id}
                className={`lb-cat-card ${activeCategory === c.id ? "active" : ""}`}
                onClick={() => loadBooks(c.id, c.name)}
              >
                <div className="lb-cat-name">{c.name}</div>
                <div className="lb-cat-hint">Click to view books</div>
                <button
                  className="lb-cat-edit"
                  onClick={e => { e.stopPropagation(); setEditCategory(c); setEditName(c.name); }}
                >
                  ✏️
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ══ BOOKS PANEL ══ */}
      {activeCategory && (
        <div className="lb-books-panel">
          <div className="lb-books-panel-head">
            <span className="lb-books-panel-title">
              📚 Books in "{activeName}" — {filtered.length}
            </span>
            <input
              className="lb-search"
              placeholder="Search books…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ maxWidth:"240px" }}
            />
          </div>
          {loading ? (
            <p style={{ color:"#94a3b8", fontSize:"13px" }}>Loading books…</p>
          ) : filtered.length === 0 ? (
            <p style={{ color:"#94a3b8", fontSize:"13px" }}>No books in this category.</p>
          ) : (
            <table className="lb-table">
              <thead>
                <tr><th>Title</th><th>Author</th><th>ISBN</th><th>Copies</th></tr>
              </thead>
              <tbody>
                {filtered.map(b => (
                  <tr key={b.id}>
                    <td><span className="lb-book-title">{b.title}</span></td>
                    <td>{b.author || "—"}</td>
                    <td>{b.isbn || "—"}</td>
                    <td><span className="lb-pill available">{b.total_copies}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* ══ EDIT MODAL ══ */}
      {editCategory && (
        <div className="lb-modal-overlay" onClick={() => setEditCategory(null)}>
          <div className="lb-modal" onClick={e => e.stopPropagation()}>
            <div className="lb-modal-head">
              <span style={{ fontSize:"22px" }}>✏️</span>
              <h3>Edit Category</h3>
            </div>
            <div className="lb-modal-body">
              <label style={{ fontSize:"12px", fontWeight:800, color:"#374151", textTransform:"uppercase", letterSpacing:".05em", display:"block", marginBottom:"8px" }}>
                Category Name
              </label>
              <input
                value={editName}
                onChange={e => setEditName(e.target.value)}
                placeholder="Category name"
                autoFocus
              />
            </div>
            <div className="lb-modal-actions">
              <button className="lb-modal-cancel" onClick={() => setEditCategory(null)}>Cancel</button>
              <button className="lb-modal-save" onClick={saveEdit}>✓ Save</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
